import React from "react"
import styled from "styled-components"
import MenuButton from "../buttons/MenuButton"
import { tooltipData } from "../data/menuData"

function MenuTooltips(props) {
  const { isOpen } = props

  return (
    <Wrapper isOpen={isOpen}>
      {tooltipData.map((item, index) => (
        <MenuButton key={index} item={item} />
      ))}
    </Wrapper>
  )
}

export default MenuTooltips

const Wrapper = styled.div`
  position: absolute;
  top: 100px;
  right: 30px;
  background: rgba(15, 14, 71, 0.3);
  box-shadow: 0px 50px 100px rgba(0, 0, 0, 0.25),
    inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  padding: 20px;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  z-index: 1;
  transition: 0.3s ease-in-out;
  display: none;
`
